// Add this JavaScript to your theme
document.addEventListener('DOMContentLoaded', function() {
  // Detect if device is mobile
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  // Add a class to the body to enable device-specific CSS
  document.body.classList.add(isMobile ? 'mobile-device' : 'desktop-device');
  
  // Early exit for mobile devices - completely disable the effect
  if (isMobile) {
    return; // Stop execution for mobile devices
  }
  
  // Only desktop code runs below this point
  // -------------------------------------
  
  // Select images for parallax effect (grid items and hero sections)
  const parallaxImages = document.querySelectorAll('.grid-item img:not([src$=".svg"]), .hero img:not([src$=".svg"]), .hero-image img:not([src$=".svg"]), .section-hero img:not([src$=".svg"])');
  
  // Set parallax intensity for desktop only
  const parallaxIntensity = 0.1;
  
  // Create intersection observer to only apply effect when items are visible
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('parallax-active');
      } else {
        entry.target.classList.remove('parallax-active');
      }
    });
  }, { threshold: 0.1, rootMargin: "20% 0px" });
  
  // Apply to each image (desktop only)
  parallaxImages.forEach(item => {
    // Desktop: smooth transition
    item.style.transition = 'transform 0.2s cubic-bezier(0.33, 1, 0.68, 1)';
    item.style.willChange = 'transform';
    
    // Observe the item
    observer.observe(item);
  });
  
  // Use a throttled scroll handler
  let lastScrollTime = 0;
  const scrollThreshold = 16;
  
  window.addEventListener('scroll', function() {
    const now = Date.now();
    if (now - lastScrollTime > scrollThreshold) {
      window.requestAnimationFrame(function() {
        const activeItems = document.querySelectorAll('.parallax-active');
        activeItems.forEach(item => {
          // Calculate how far the item is from the top of the viewport
          const rect = item.getBoundingClientRect();
          const scrollPosition = window.innerHeight - rect.top;
          
          // Apply the transform
          const moveY = Math.round(scrollPosition * parallaxIntensity);
          
          // Store the last applied transform value if it doesn't exist yet
          if (!item.lastAppliedY) {
            item.lastAppliedY = 0;
          }
          
          // Only apply if different enough from last position
          if (Math.abs(moveY - item.lastAppliedY) >= 2) {
            item.style.transform = `translateY(${moveY}px)`;
            item.lastAppliedY = moveY;
          }
        });
      });
      lastScrollTime = now;
    }
  }, { passive: true });
});